import * as classNames from 'classnames';
import * as React from 'react';
import withStyles, { StyledComponentProps } from 'react-jss';
import { RouteComponentProps, withRouter } from 'react-router';
import { Link } from 'react-router-dom';
import { InjectedCursorProps, withCursor } from 'src/_context/Cursor';
import Responsive from 'src/_context/Responsive';
import responsive from 'src/constants/responsive';
import spacing from 'src/constants/spacing';
import stylesheet, { directions } from 'src/constants/stylesheet';
import { Language } from 'src/utils/Languages';
import Image from './Image';
import Overview from './Overview';
import { Slider, SliderState } from './Slider';
import CurrentIndex from './Slider/CurrentIndex';
import SliderRail, { RailZone } from './SliderRail';

export type ProjectDetailProps = ProjectDto;

const styles = {
  container: {
    display: 'flex',
    flexDirection: 'column',
    height: '100%'
  },
  mobileContainer: {
    height: '100%',
    overflow: 'auto',
    '-webkit-overflow-scrolling': 'touch'
  },
  header: {
    display: 'flex',
    flex: '0 0 auto',
    ...stylesheet.PaddingGutter(.5, directions.sides | directions.top)
  },
  headerMobile: {
    position: 'sticky',
    top: 0,
    ...stylesheet.PaddingGutter(1, directions.all)
  },
  headerTitle: {
    [responsive.Mobile]: {
      width: spacing.MainLeftSideWidth.Mobile,
      padding: `${spacing.Gutter.Mobile / 2}px ${spacing.Gutter.Mobile / 2}px 0 ${spacing.Gutter.Mobile / 2}px`
    },
    [responsive.Tablet]: {
      width: spacing.MainLeftSideWidth.Tablet,
      padding: `${spacing.Gutter.Tablet / 2}px ${spacing.Gutter.Tablet / 2}px 0 ${spacing.Gutter.Tablet / 2}px`
    },
    [responsive.Laptop]: {
      width: `${100 / 3}vw`,
      padding: `${spacing.Gutter.Laptop / 2}px ${spacing.Gutter.Laptop / 2}px 0 ${spacing.Gutter.Laptop / 2}px`
    },
    [responsive.Desktop]: {
      width: `${100 / 3}vw`,
      padding: `${spacing.Gutter.Desktop / 2}px ${spacing.Gutter.Desktop / 2}px 0 ${spacing.Gutter.Desktop / 2}px`
    }
  },
  headerCounter: {
    [responsive.Mobile]: {
      // width: spacing.MainRightSideWidth.Mobile,
      padding: `${spacing.Gutter.Mobile / 2}px ${spacing.Gutter.Mobile / 2}px 0 ${spacing.Gutter.Mobile / 2}px`
    },
    [responsive.Tablet]: {
      // width: spacing.MainRightSideWidth.Tablet,
      padding: `${spacing.Gutter.Tablet / 2}px ${spacing.Gutter.Tablet / 2}px 0 ${spacing.Gutter.Tablet / 2}px`
    },
    [responsive.Laptop]: {
      // width: spacing.MainRightSideWidth.Laptop,
      padding: `${spacing.Gutter.Laptop / 2}px ${spacing.Gutter.Laptop / 2}px 0 ${spacing.Gutter.Laptop / 2}px`
    },
    [responsive.Desktop]: {
      // width: spacing.MainRightSideWidth.Desktop,
      padding: `${spacing.Gutter.Desktop / 2}px ${spacing.Gutter.Desktop / 2}px 0 ${spacing.Gutter.Desktop / 2}px`
    }
  },
  headerContentMobile: {
    ...stylesheet.MarginGutter(.5, directions.sides | directions.bottom)
  },
  title: {
    color: 'black'
  },
  subTitle: {},
  sliderContainer: {
    position: 'relative',
    flex: '1 1',
    overflow: 'hidden',
    // ...stylesheet.MarginGutter(1, directions.top)
  },
  sliderContainerInner: {
    position: 'relative',
    width: '100%',
    [responsive.Mobile]: {
      marginTop: spacing.Gutter.Mobile,
      height: `calc(100% - ${spacing.Gutter.Mobile}px)`,
    },
    [responsive.Tablet]: {
      marginTop: spacing.Gutter.Tablet,
      height: `calc(100% - ${spacing.Gutter.Tablet}px)`,
    },
    [responsive.Laptop]: {
      marginTop: spacing.Gutter.Laptop,
      height: `calc(100% - ${spacing.Gutter.Laptop}px)`,
    },
    [responsive.Desktop]: {
      marginTop: spacing.Gutter.Desktop,
      height: `calc(100% - ${spacing.Gutter.Desktop}px)`,
    }
  },
  textContainer: {
    [responsive.Mobile]: {
      width: '100%',
      padding: `0 ${spacing.Gutter.Mobile}px ${spacing.Gutter.Mobile}px ${spacing.Gutter.Mobile}px`
    },
    [responsive.AfterMobile]: {
      height: '100%',
      '-webkit-overflow-scrolling': 'touch',
      overflow: 'auto'

    },
    [responsive.Tablet]: {
      paddingLeft: spacing.Gutter.Tablet / 2
    },
    [responsive.Laptop]: {
      paddingLeft: spacing.Gutter.Laptop / 2
    },
    [responsive.Desktop]: {
      paddingLeft: spacing.Gutter.Desktop / 2
    }
  },
  text: {
    [responsive.Mobile]: {
    },
    [responsive.Tablet]: {
      paddingLeft: '50%'
    },
    [responsive.Laptop]: {
      paddingLeft: `${(100 / 6) * 2}vw`
    },
    [responsive.Desktop]: {
      paddingLeft: `${(100 / 6) * 2}vw`
    }
  },
  textInner: {
    [responsive.Mobile]: {
      width: '100%',
    },
    [responsive.Tablet]: {
      width: '100%',
      padding: `0 ${spacing.Gutter.Tablet / 2}px ${spacing.Gutter.Tablet}px ${spacing.Gutter.Tablet / 2}px`
    },
    [responsive.Laptop]: {
      width: `${(100 / 4) * 3}%`,
      paddingLeft: spacing.Gutter.Laptop / 2,
      paddingBottom: spacing.Gutter.Laptop
    },
    [responsive.Desktop]: {
      width: `${(100 / 4) * 3}%`,
      paddingLeft: spacing.Gutter.Desktop / 2,
      paddingBottom: spacing.Gutter.Laptop
    }
  },
  imageContainer: {
    [responsive.Mobile]: {
      width: '100%',
      padding: `0 ${spacing.Gutter.Mobile}px ${spacing.Gutter.Mobile}px ${spacing.Gutter.Mobile}px`
    },
    [responsive.AfterMobile]: {
      height: '100%'
    },
    [responsive.Tablet]: {
      padding: `0 ${spacing.Gutter.Tablet}px ${spacing.Gutter.Tablet}px ${spacing.Gutter.Tablet}px`
    },
    [responsive.Laptop]: {
      padding:
        `0 ${spacing.Gutter.Laptop * 2 + spacing.Logo.Laptop}px ${spacing.Gutter.Laptop}px ${spacing.Gutter.Laptop}px`
    },
    [responsive.Desktop]: {
      padding:
        // tslint:disable-next-line:max-line-length
        `0 ${spacing.Gutter.Desktop * 2 + spacing.Logo.Laptop}px ${spacing.Gutter.Desktop}px ${spacing.Gutter.Desktop}px`
    }
  },
  image: {
    display: 'block',
    width: '100%',
    height: '100%',
    objectFit: 'contain',
    objectPosition: 'bottom left',
    pointerEvents: 'none',
    [responsive.Mobile]: {
      objectPosition: 'top left'
    },
    [responsive.AfterMobile]: {
      objectPosition: 'bottom left'
    }
  },
  slideNext: {
    position: 'absolute',
    top: 0,
    bottom: 0,
    width: '50%',
    right: 0
  },
  slidePrevios: {
    position: 'absolute',
    top: 0,
    bottom: 0,
    width: '50%',
    left: 0
  },
  containerOverview: {
    position: 'absolute',
    top: '100%',
    left: 0,
    right: 0,
    height: '100%',
    '-webkit-overflow-scrolling': 'touch',
    overflow: 'auto',
    background: 'white',
    zIndex: 9999,
    transition: 'all .7s ease',
    boxSizing: 'content-box',
  },
  showOverview: {
    top: 0
  },
  mobileProjectNav: {
    ...stylesheet.MarginGutter(1, directions.bottom | directions.sides)
  },
  mobilePreviousProjectLink: {
    display: 'block'
  },
  mobileNextProjectLink: {
    display: 'block',
    ...stylesheet.MarginGutter(1, directions.bottom)
  },
  mobileGoTopLink: {
    display: 'block'
  },
}
type Props = ProjectDetailProps &
  InjectedCursorProps &
  RouteComponentProps<any> &
  StyledComponentProps<keyof typeof styles>;

type State = {
  current: number;
  overviewOpen: boolean;
  overviewLoaded: boolean;
}
class ProjectDetail extends React.Component<Props, State> {

  constructor(props: Props) {
    super(props);
    this._hover = this._hover.bind(this);
    this._toggleOverview = this._toggleOverview.bind(this);
    this._cursorDefault = this._cursorDefault.bind(this);
    this._scrollTop = this._scrollTop.bind(this);

    const hash = window.location.hash.replace("#", "");
    let current = 0;
    if (hash === 'last') {
      window.location.hash = '';
      current = this.props.Slides.length - 1;
    } else if (hash === 'first') {
      current = 0;
    } else if (hash) {
      const parsed = parseInt(hash, 10);
      if (!isNaN(parsed) && isFinite(parsed)) {
        current = parsed;
      }
    }
    this.state = {
      current,
      overviewOpen: false,
      overviewLoaded: false
    };
  }
  public render() {

    const { classes, PreviousUID, NextUID } = this.props;
    const { overviewOpen, overviewLoaded } = this.state;

    const pageDto = this.props as ProjectDto;
    const slides = pageDto.Slides.map((s, i) => {
      switch (s.type) {
        case "SlideImage":

          const panelImage = s as PanelImageDto;
          return (
            <div key={i} className={classes!.imageContainer}>
              <Image
                className={classes!.image}
                pictureRef={panelImage.Image} sizes="100vw"
              />
            </div>);

        case "SlideText":

          const panelText = s as PanelTextDto;
          return (
            <div key={i} className={classes!.textContainer}>
              <div className={classes!.text}>
                <div className={classes!.textInner}
                  dangerouslySetInnerHTML={{ __html: panelText.Text }}
                />
              </div>
            </div>);
        default: return null;
      }
    });

    return (
      <React.Fragment>
        <Responsive.Consumer steps={['Mobile']}>
          <div
            className={classes!.mobileContainer}
            id="scrollContainer"
          >
            <div className={classes!.headerMobile}>
              <h2 className={classes!.title}>
                {pageDto.Title}
              </h2>
              <h3 className={classes!.subTitle}>
                {pageDto.Location}
              </h3>
            </div>
            {slides}
            <div className={classes!.mobileProjectNav}>
              <Link
                to={`/${Language}/projects/${PreviousUID}`}
                className={classes!.mobilePreviousProjectLink}
              >
                {Language === 'en' ? 'Previous project' : 'Projet précédent'}
              </Link>
              <Link
                to={`/${Language}/projects/${NextUID}`}
                className={classes!.mobileNextProjectLink}
              >
                {Language === 'en' ? 'Next project' : 'Projet suivant'}
              </Link>
              <a
                onClick={this._scrollTop}
                className={classes!.mobileGoTopLink}
              >
                {Language === 'en' ? 'Go to top' : 'Haut de page'}
              </a>
            </div>
          </div>
        </Responsive.Consumer>
        <Responsive.Consumer steps={['AfterMobile']}>
          <div className={classes!.container}>
            <Slider width={100} nodes={slides} current={this.state.current} onChange={this._sliderChange} loop={true}>
              <div className={classes!.header}>
                <div className={classes!.headerTitle}>
                  <h2 className={classes!.title}>
                    {pageDto.Title}
                  </h2>
                  <h3 className={classes!.subTitle}>
                    {pageDto.Location}
                  </h3>
                </div>
                <div className={classNames(classes!.headerCounter)}>
                  <div className={classes!.title}><CurrentIndex />{` — ${pageDto.Slides.length}`}</div>
                  <a
                    className={classes!.subTitle}
                    onClick={this._toggleOverview}
                  >
                    {overviewOpen ? 'Diaporama' : Language === 'en' ? 'Overview' : 'Vue d’ensemble'}
                  </a>
                </div>
              </div>
              <div className={classes!.sliderContainer}>
                <Slider.Consumer>
                  {(context) => {

                    const click = (zone: RailZone) => this._click(zone, context);
                    return (
                      <React.Fragment>
                        <div className={classes!.sliderContainerInner}>
                          <SliderRail
                            leave={this._cursorDefault}
                            hasCenter={false}
                            click={click}
                            hover={this._hover}
                          />
                        </div>
                        <div
                          className={
                            classNames(classes!.containerOverview, overviewOpen ? classes!.showOverview : '')}
                        >
                          {overviewLoaded &&
                            <Overview
                              slides={pageDto.Slides}
                              // tslint:disable-next-line:jsx-no-lambda
                              goTotSLide={(n) => {
                                this.setState(() => ({ overviewOpen: false }));
                                context.go(n);
                              }}
                            />
                          }
                        </div>
                      </React.Fragment>
                    )
                  }}
                </Slider.Consumer>
              </div>
            </Slider>
          </div>
        </Responsive.Consumer>
      </React.Fragment>
    );
  }

  private _click(zone: RailZone, state: SliderState) {
    const { goNext, goPrevious } = state;

    switch (zone) {
      case 'center':
        break;
      case 'previous':
        goPrevious();
        break;
      case 'next':
        goNext();
        break;
    }
  }

  private _hover(zone: RailZone) {
    switch (zone) {
      case 'center':
        break;
      case 'previous':
        this.props.cursor.setType('previous')
        break;
      case 'next':
        this.props.cursor.setType('next');
        break;
      default:
        this.props.cursor.setType('default');
        break;
    }
  }

  // private _nextProject() {
  //   const { history: { push }, NextUID } = this.props;
  //   if (NextUID) {
  //     push(`/${Language}/projects/${NextUID}#first`);
  //   }
  // }
  // private _previousProject() {
  //   const { history: { push }, PreviousUID } = this.props;
  //   if (PreviousUID) {
  //     push(`/${Language}/projects/${PreviousUID}#last`)
  //   }
  // }
  // private _cursorNext() {
  //   const { cursor: { setType } } = this.props;
  //   setType('next');
  // }

  private _sliderChange(i: number) {
    window.location.hash = '#' + i;
  }

  // private _cursorNextProject() {
  //   const { cursor: { setType }, NextUID } = this.props;
  //   if (NextUID) {
  //     setType('nextProject');
  //   } else {
  //     setType('default');
  //   }
  // }
  private _cursorDefault() {
    const { cursor: { setType } } = this.props;
    setType('default');
  }

  // private _cursorPrevious() {
  //   const { cursor: { setType } } = this.props;
  //   setType('previous');
  // }

  // private _cursorPreviousProject() {
  //   const { cursor: { setType }, PreviousUID } = this.props;
  //   if (PreviousUID) {
  //     setType('previousProject');
  //   } else {
  //     setType('default');
  //   }
  // }

  private _toggleOverview() {
    this.setState((prev) => ({
      overviewOpen: !prev.overviewOpen,
      overviewLoaded: prev.overviewLoaded ? prev.overviewLoaded : !prev.overviewLoaded
    }))
  }

  private _scrollTop() {
    const scrollContainer = document.getElementById("scrollContainer");
    if (!scrollContainer) { return }

    scrollContainer.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
  }
}

export default withStyles(styles)(withCursor(withRouter(ProjectDetail)));



// WEBPACK FOOTER //
// ./src/components/ProjectDetail.tsx